(function () {
  "use strict";

  function initBestsellersSwiper(section, panel) {
    var el = panel.querySelector("[data-bestsellers-swiper]");
    if (!el || typeof Swiper === "undefined") return null;

    if (el.swiper) {
      el.swiper.destroy(true, true);
    }

    var prev = section.querySelector(".kg-bestsellers__nav-btn--prev");
    var next = section.querySelector(".kg-bestsellers__nav-btn--next");

    return new Swiper(el, {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 0,
      roundLengths: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      navigation: {
        prevEl: prev,
        nextEl: next
      }
    });
  }

  function initVisibleSwiper(section) {
    var visible = section.querySelector(".collection-block:not(.hidden)");
    if (visible) {
      initBestsellersSwiper(section, visible);
    }
  }

  function bindSection(section) {
    if (section.dataset.kgBestsellersBound === "true") return;
    section.dataset.kgBestsellersBound = "true";

    var tabs = section.querySelectorAll(".collection-tab-item");
    var panels = section.querySelectorAll(".collection-block");

    function showPanel(handle) {
      panels.forEach(function (panel) {
        var isMatch = panel.id === "collection-" + handle;
        panel.classList.toggle("hidden", !isMatch);
        if (isMatch) {
          initBestsellersSwiper(section, panel);
        }
      });
    }

    tabs.forEach(function (tab) {
      function activate() {
        tabs.forEach(function (t) {
          t.classList.remove("active");
          t.setAttribute("aria-selected", "false");
        });
        tab.classList.add("active");
        tab.setAttribute("aria-selected", "true");
        showPanel(tab.dataset.handle);
      }

      tab.addEventListener("click", activate);
      tab.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          activate();
        }
      });
    });

    var tabContainer = section.querySelector(".collection-tab");
    if (tabContainer) {
      var isDown = false;
      var startX = 0;
      var scrollLeft = 0;

      tabContainer.addEventListener("mousedown", function (e) {
        isDown = true;
        tabContainer.classList.add("dragging");
        startX = e.pageX - tabContainer.offsetLeft;
        scrollLeft = tabContainer.scrollLeft;
      });
      tabContainer.addEventListener("mouseleave", function () {
        isDown = false;
        tabContainer.classList.remove("dragging");
      });
      tabContainer.addEventListener("mouseup", function () {
        isDown = false;
        tabContainer.classList.remove("dragging");
      });
      tabContainer.addEventListener("mousemove", function (e) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX - tabContainer.offsetLeft;
        tabContainer.scrollLeft = scrollLeft - (x - startX) * 2;
      });
    }

    initVisibleSwiper(section);
  }

  function boot() {
    document.querySelectorAll("[data-kg-bestsellers]").forEach(bindSection);
  }

  function initAllSwipers() {
    document.querySelectorAll("[data-kg-bestsellers]").forEach(initVisibleSwiper);
  }

  function bootWhenReady() {
    boot();
    if (typeof Swiper === "undefined") {
      window.addEventListener(
        "load",
        function () {
          initAllSwipers();
        },
        { once: true }
      );
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootWhenReady);
  } else {
    bootWhenReady();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target.querySelector("[data-kg-bestsellers]");
    if (section) {
      bindSection(section);
    }
  });
})();
